import $ from 'jquery';
import { ajaxifyBasket } from './headerBasket';

export default function headerCartRefresh() {

	let targetUrl = 'eshop-kosik.html';
	let refreshes = [
		'.header__basket',
	];

	$.get(targetUrl)
		.done(function(response) {
			
			let $parsedResponse = $(response);

			for (let refreshSelector of refreshes) {
				let newSource = $parsedResponse.find(refreshSelector);
				let targetPlace = $(refreshSelector);
				if (newSource.length === 1 && targetPlace.length === 1) {
					targetPlace.html(newSource.html());
					setTimeout(function() {
						ajaxifyBasket();
					}, 0);
				} else {
					console.error(
						'Can\'t ajax-refresh this:',
						refreshSelector,
						'newSource.length',
						newSource.length,
						'targetPlace.length',
						targetPlace.length
					);
				}
			
			}


		})

};


window['headerCartRefresh'] = headerCartRefresh;
